import {legacy_createStore as createStore } from "redux";
import {itemReducer} from "./reducer.js";


const store = createStore(
    itemReducer,
    
); 

export {store};